module.exports = "https://coursera_assets.s3.amazonaws.com/images/d6c5f4a4cf54e0fd4bbd4f3a2ebf67f0.png";